import React from 'react';
import { useSelector } from 'react-redux';
import { isLivestreamPreviewActive } from 'services/admin';
import { isLivestreamPublished as isPublishedLivestream } from 'services/livestream/selectors';
import { VIDEO_ID } from 'global-ids';
import Player from 'components/Video/video-player/Player';
import { CastProvider } from 'react-cast-sender';
import { PlayerProps } from '../video-player/Player/interfaces';

const DEFAULT_APP_ID = 'CC1AD845';

export const VideoPlayback = (playerProps: PlayerProps) => {
  const isPreviewingLivestream = useSelector(isLivestreamPreviewActive);
  const isLivestreamPublished = useSelector(isPublishedLivestream);

  return (
    <CastProvider receiverApplicationId={DEFAULT_APP_ID}>
      <Player
        activeVideoElementId={VIDEO_ID}
        blank={isPreviewingLivestream && !isLivestreamPublished}
        {...playerProps}
      />
    </CastProvider>
  );
};
